<template>
  <div>
    <!--    <page-header></page-header>-->
    <div>
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="icon-title word-type pb-0"
          ><icon-application :width="24" :height="24" />설문지</v-col
        >
      </v-row>

      <v-row class="ma-0">
        <v-col cols="12" class="px-6 py-5 appr-doc-list-wrap">
          <!-- empty Data component -->
          <empty-data
            v-if="emptyDataFlag"
            v-bind:text="emptyDataText"
          ></empty-data>

          <!-- 설문지 목록 -->
          <v-list v-else flat>
            <v-list-item-group>
              <v-list-item
                :ripple="false"
                v-for="item in searchList"
                :key="item.applSeq"
              >
                <v-card elevation="0" class="doc-box">
                  <v-row class="ma-0" @click="openViewer(item)">
                    <v-col cols="12" class="pa-0">
                      <v-list-item class="px-0">
                        <v-list-item-icon class="avatar-wrap">
                          <v-avatar color="white" class="with-icon">
                            <!-- 신청서종류 따라 아이콘 변경 -->
                            <appl-menu-icon
                              :propsParam="{
                                applCd: item.applCd,
                                gntGubunCd: item.gubunCd,
                              }"
                              :styleClassStr="'mr-0'"
                            />
                          </v-avatar>
                        </v-list-item-icon>
                        <v-list-item-content class="pa-0">
                          <v-list-item-title
                            class="card-title"
                            style="white-space: normal"
                          >
                            멘토양성과정 교육설문1멘토양성과정 교육설문1
                          </v-list-item-title>
                          <v-list-item-subtitle class="desc">
                            <span></span> 2024-02-15 ~ 2024-06-28
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="desc">
                            <span>무기명</span>
                            <span class="divider"></span>
                            <span>비공개</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <!--div class="arrow-wrap">
                          <v-btn
                            fab
                            text
                            width="24"
                            height="24"
                            color="grey darken-2"
                          >
                            <v-icon size="24">mdi-chevron-right</v-icon>
                          </v-btn>
                        </div-->
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-card-actions class="pa-0 mt-4">
                    <v-row align="center" justify="space-around" class="ma-0">
                      <v-btn
                        class="btn-sign"
                        elevation="0"
                        color="deepGrey"
                        @click="doApplConfirm(item)"
                      >
                        <span class="white--text">
                          <!--v-icon size="18">mdi-check</v-icon-->
                          참여
                        </span>
                      </v-btn>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
/* 결재할문서 */
import EmptyData from '@/components/common/EmptyData.vue';
import IconApplication from '@/assets/customIcon/IconApplication.vue';
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import { mapGetters, mapMutations } from 'vuex';
import { getApprDocList, postApplConfirm } from '@/api/allDoc.js';
import messageConstants from '@/const/messageConstants.js';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
//import PageHeader from '@/components/common/PageHeader.vue';

export default {
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
    };
  },

  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
  },

  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchApprDocList();
      }
    },
  },

  methods: {
    ...mapMutations('DIALOG', ['SET_DIALOG_PARAM', 'TOGGLE_MODAL']),
    ...mapMutations('SPINNER', ['ON_COMMON_SPINNER', 'OFF_COMMON_SPINNER']),

    /* 신청서뷰어 모달오픈 */
    openViewer(appInfo) {
      this.SET_DIALOG_PARAM(appInfo);
      // console.log('appInfo : ' + JSON.stringify(appInfo));
      this.TOGGLE_MODAL('application_viewer');
    },

    /* 참여하기 */
    doApplConfirm(item) {
      if (confirm('참여하시겠습니까?')) {
        this.ON_COMMON_SPINNER(); // 공통 스피너 ON
        this.saveApplConfirm(item);
      }
    },

    /* 참여할문서 조회 */
    async fetchApprDocList() {
      const paramObj = {
        //searchFrom: dayjs().subtract(12, 'month').format('YYYYMMDD'),
        //searchTo: dayjs().format('YYYYMMDD'), // 조회기간(한달전~현재)
        // multiSearchApplCd: "'22','23','30','42','43','110','301'", // 조회신청서코드(근무,근태관련)
        searchDate: dayjs().format('YYYY'),
      };

      try {
        const response = await getApprDocList(paramObj);
        const dataList = response.data.data;

        const apprDocList = [];
        dataList.forEach(data => {
          apprDocList.push({
            ...data,
            applYmdFormat: dayjs(data.applYmd)
              .locale('ko')
              .format('YYYY.MM.DD (dd)'),
          });
        });
        this.searchList = apprDocList;

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
        this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', false); // 모달 종료 콜백 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },

    /* 결재승인 저장 */
    async saveApplConfirm(item) {
      // console.log('item ::: ' + JSON.stringify(item));
      const param = {
        mergeRows: [
          {
            applSabun: item.applSabun,
            applSeq: item.applSeq.toString(),
            applCd: item.applCd,
            agreeSeq: item.agreeSeq.toString(),
            agreeGubun: item.agreeGubun,
            applStatusCd: item.applStatusCd,
          },
        ],
      };

      try {
        const response = await postApplConfirm(param);

        if (response == null || response.data.data.Result < 0) {
          alert('처리중 오류가 발생했습니다.');
        } else {
          alert('참여하였습니다.');
          // console.log(response.data.data.Message);
          this.fetchApprDocList(); // 재조회
        }

        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },
  },

  created() {
    this.ON_COMMON_SPINNER(); // 공통 스피너 ON
    this.fetchApprDocList();
  },

  components: {
    // PageHeader,
    EmptyData,
    ApplMenuIcon,
    IconApplication,
  },
};
</script>

<style scoped>
.v-list .v-list-item {
  border-radius: 12px;
  margin-top: 8px;
  background: #f5f6f7;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
